export var Lang;
(function (Lang) {
    Lang["EN"] = "en";
    Lang["RU"] = "ru";
})(Lang || (Lang = {}));
